export const translations = {
  wallet_label: 'Wallet',
  wallet_label_upper: 'WALLET',
  balance_label: 'BALANCE:',

  voucher_heading_start: 'Claim your cool ',
  voucher_heading_emphasis: 'reward',
  voucher_subtitle: 'Please select which coupon you would like.',
  voucher_remaining: '{0} Remaining',
  voucher_daily_limit: 'Daily Limit Reached',
  submit_btn: 'SUBMIT',
  go_to_site: 'Go to {0}',

  menu_coupons: 'COUPONS',
  menu_balance: 'Balance',
  menu_validity: 'Coupon Validity',
  menu_terms: 'Terms and Conditions',

  coupon_status_claimed: 'Claimed',
  coupon_status_active: 'Active',
  coupon_expires: 'Expires {0}',
  view_pin: 'View Pin',
  historic_coupons: 'HISTORIC COUPONS',
  no_active_coupons: 'No active coupons yet.',
  no_historic_coupons: 'No historic coupons.',

  pin_label: 'PIN:',
  pin_copy: 'Copy',

  validity_heading: 'COUPON VALIDITY',
  validity_body_1: 'Turn those hard-earned coins into real rewards! You can now buy coupons directly from the shop using your in-game balance.',
  validity_body_2: 'Just remember: once you purchase a pin, you have 7 days to redeem it and an additional 30 days to claim your prize. Daily stock is limited, so if your favorite coupon is gone, grab it first thing tomorrow—or save up those coins for an even higher-tier reward!',

  terms_heading: 'REWARDS TS &Cs',

  back_to_store: 'Return Home',
  try_again: 'Try Again',
}
